module.exports = __webpack_public_path__ + "static/img/42.5550747.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/42.png
// module id = g3hc
// module chunks = 0